import { useTranslation } from "react-i18next";
import { Col, Container, Row } from "reactstrap"
import Tabs from "src/components/Common/UI/Tabs/Tabs"

const ParametersHeaders = () => {
  const { t } = useTranslation();

  const tabList = [
    {name: "Γεωγραφικοί", path: "/configuration/parameters/geographicals"},
    {name: "Υλικό", path: "/configuration/parameters/equipment"},
    {name: "ΑΤΜ", path: "/configuration/parameters/atm"},
    {name: "Γραμμές", path: "/configuration/parameters/lines"},
    {name: "Χρεώσεις", path: "/configuration/parameters/billings"},
    //{name: "Τ.Κ.", path: "/configuration/parameters/phonecenters"},
    {name: "Άλλες", path: "/configuration/parameters/others"},
    
  ]
  
  return (
    <Container fluid>
      <Row>
        <Col xs={12} className="mb-3">
          <span className="h1">{t("Παράμετροι")}</span>
        </Col>
        <Col xs={12}>
          <Tabs tabList={tabList} />
        </Col>
      </Row>
    </Container>
  )
}

export default ParametersHeaders;
